export const AUTH_AUDIENCES = {
  JOB_SEEKER: "job_seeker",
  DISTRICT_STAFF: "district_staff",
} as const;

export type AuthAudience = (typeof AUTH_AUDIENCES)[keyof typeof AUTH_AUDIENCES];
